<app-modal [isOpen]="isOpen" [showCloseButton]="false" [preventDismiss]="true" [className]="'max-w-md p-6'"
  (close)="onLogoutNow()">
  @if (sessionExpired) {
  <!-- Session Expired State -->
  <div class="flex flex-col items-center text-center">
    <!-- Icon -->
    <div class="mb-5 flex items-center justify-center">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 20C10 14.4772 14.4772 10 20 10H60C65.5228 10 70 14.4772 70 20V50C70 55.5228 65.5228 60 60 60H20C14.4772 60 10 55.5228 10 50V20Z"
          stroke="#5C77FF" stroke-width="5" fill="none" />
        <path d="M10 28H70" stroke="#5C77FF" stroke-width="4" />
        <circle cx="20" cy="19" r="2.5" fill="#5C77FF" />
        <circle cx="28" cy="19" r="2.5" fill="#5C77FF" />
        <circle cx="36" cy="19" r="2.5" fill="#5C77FF" />
        <circle cx="62" cy="62" r="16" fill="#5C77FF" stroke="white" stroke-width="4" />
        <path d="M62 56V64" stroke="white" stroke-width="3" stroke-linecap="round" />
        <circle cx="62" cy="70" r="2" fill="white" />
      </svg>
    </div>

    <h3 class="mb-2 text-xl font-bold text-gray-900 dark:text-white">
      Your session has expired due to inactivity
    </h3>

    <p class="mb-8 text-sm text-gray-500 dark:text-gray-400">
      Please refresh the page. You will be redirected to the Login page.
    </p>

    <button type="button" (click)="onRefresh()"
      class="flex w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
      Refresh
    </button>
  </div>
  } @else {
  <!-- Warning State -->
  <div class="flex flex-col items-center text-center">
    <h3 class="mb-3 text-xl font-bold text-gray-900 dark:text-white" id="modal-title">
      You will be logged out soon
    </h3>

    <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
      For your security, we log you out automatically when you have not been active for a certain period of time.
    </p>

    <div class="mb-8 font-mono text-3xl font-bold text-gray-900 dark:text-white">
      {{ formattedTime }}
    </div>

    <div class="flex w-full gap-3">
      <button type="button" (click)="onLogoutNow()"
        class="flex flex-1 items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
        Log Out Now
      </button>
      <button type="button" (click)="onContinueSession()"
        class="flex flex-1 items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
        Continue Session
      </button>
    </div>
  </div>
  }
</app-modal>